import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { login, getSysUser } from '@/api/user';
import { jsonInBlacklist } from '@/api/jwt';
import router from '@/router/index';
import { Common } from '@/utils/common';
export var user = {
  namespaced: true,
  state: {
    userInfo: {
      uuid: '',
      nickName: '',
      headerImg: '',
      authority: '',
      sellerId: 0,
      queryDataDays: 7,
      queryDataRatio: 0.4
    },
    token: ''
  },
  mutations: {
    setUserInfo: function setUserInfo(state, userInfo) {
      // 这里的 `state` 对象是模块的局部状态
      state.userInfo = userInfo;
    },
    setToken: function setToken(state, token) {
      // 这里的 `state` 对象是模块的局部状态
      state.token = token;
    },
    NeedInit: function NeedInit(state) {
      state.userInfo = {};
      state.token = '';
      sessionStorage.clear();
      router.push({
        name: 'Init',
        replace: true
      });
    },
    LoginOut: function LoginOut(state) {
      console.log('LoginOut:', state.token);
      state.userInfo = {};
      state.token = '';
      sessionStorage.clear();
      router.push({
        name: 'Login',
        replace: true
      });
      window.location.href = Common.delQueryString('token');
    },
    ResetUserInfo: function ResetUserInfo(state) {
      var userInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      state.userInfo = _objectSpread(_objectSpread({}, state.userInfo), userInfo);
    }
  },
  actions: {
    LoginIn: function LoginIn(_ref, loginInfo) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var commit, dispatch, rootGetters, getters, res, asyncRouters, asyncStations;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit, dispatch = _ref.dispatch, rootGetters = _ref.rootGetters, getters = _ref.getters;
                _context.next = 3;
                return login(loginInfo);

              case 3:
                res = _context.sent;

                if (!(res.code === 0)) {
                  _context.next = 18;
                  break;
                }

                commit('setUserInfo', res.data.user);
                commit('setToken', res.data.token);
                _context.next = 9;
                return dispatch('router/SetAsyncRouter', {}, {
                  root: true
                });

              case 9:
                _context.next = 11;
                return dispatch('stations/SetAsyncStations', {
                  groupNo: 1
                }, {
                  root: true
                });

              case 11:
                // 获取用户关联的集团站点数据
                asyncRouters = rootGetters['router/asyncRouters'];
                asyncStations = rootGetters['stations/asyncStations'];
                console.log('user.js asyncRouters', asyncRouters);
                console.log('user.js asyncStations', asyncStations);
                router.addRoutes(asyncRouters); // const redirect = router.history.current.query.redirect
                // console.log(redirect)
                // if (redirect) {
                //     router.push({ path: redirect })
                // } else {

                router.push({
                  name: getters['userInfo'].authority.defaultRouter
                }); // }

                return _context.abrupt("return", true);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    LoginOut: function LoginOut(_ref2) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var commit, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit = _ref2.commit;
                _context2.next = 3;
                return jsonInBlacklist();

              case 3:
                res = _context2.sent;

                if (res.code === 0) {
                  commit('LoginOut');
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    GetSysUser: function GetSysUser(_ref3) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var commit, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit = _ref3.commit;
                _context3.next = 3;
                return getSysUser();

              case 3:
                res = _context3.sent;

                if (res.code == 0) {
                  commit('setUserInfo', res.data);
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  },
  getters: {
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    token: function token(state) {
      return state.token;
    }
  }
};